var map = {
	"./Group.png": 81158,
	"./aboutus-icon1.svg": 53001,
	"./add-circle.png": 25522,
	"./admin-icon.svg": 20628,
	"./angry.svg": 71975,
	"./anguish.svg": 56923,
	"./animal-feet-icon.svg": 22256,
	"./app-store-icon.svg": 36027,
	"./app-store.svg": 23629,
	"./atom-bond2.svg": 48633,
	"./badge-check.svg": 63422,
	"./badge.svg": 60237,
	"./ban-img-icon-4.svg": 68748,
	"./ban-img-icon5.svg": 64877,
	"./ban-img-icon6.svg": 84381,
	"./ban-img-icon7.svg": 18207,
	"./ban-img-icon8.svg": 48655,
	"./ban-img-icon9.svg": 49888,
	"./ban-six-icon1.svg": 48541,
	"./ban-six-icon2.svg": 46237,
	"./ban-six-icon3.svg": 63459,
	"./banner-cal-icon.svg": 87764,
	"./bath-tub.svg": 42694,
	"./benefit-icon-01.svg": 52951,
	"./benefit-icon-02.svg": 44210,
	"./benefit-icon-03.svg": 29861,
	"./benefit-icon-04.svg": 37717,
	"./bg-icon-01.svg": 49575,
	"./bg-icon-02.svg": 9931,
	"./book-lab-bg-01.svg": 69472,
	"./book-lab-bg-02.svg": 54663,
	"./bookmark-star.svg": 5602,
	"./bottel.svg": 85674,
	"./browse-01.jpg": 50156,
	"./browse-02.jpg": 36901,
	"./browse-03.jpg": 58668,
	"./browse-04.jpg": 10884,
	"./browse-05.jpg": 51365,
	"./browse-categorie.svg": 62357,
	"./building-icon.svg": 80971,
	"./bullseye.svg": 33726,
	"./calendar3.svg": 1491,
	"./camera.svg": 72952,
	"./cardiology.png": 67686,
	"./care-01.svg": 60055,
	"./care-02.svg": 36198,
	"./care-03.svg": 61318,
	"./care-04.svg": 87237,
	"./care-05.svg": 48321,
	"./care-big-01.svg": 35589,
	"./care-big-02.svg": 11225,
	"./care-big-03.svg": 25545,
	"./care-big-04.svg": 15451,
	"./care-big-05.svg": 49879,
	"./cart-favourite.svg": 86252,
	"./ch.svg": 6374,
	"./check.svg": 73028,
	"./choose-01.svg": 87583,
	"./choose-02.svg": 80604,
	"./choose-03.svg": 89169,
	"./choose-04.svg": 44502,
	"./choose-icon.svg": 4285,
	"./choose-icon1.svg": 62767,
	"./choose-icon2.svg": 20445,
	"./choose-icon3.svg": 55885,
	"./choose-icon4.svg": 14566,
	"./clinic-01.png": 67537,
	"./clinic-02.png": 46314,
	"./clinic-03.png": 77653,
	"./clinic-04.png": 29946,
	"./clinic-05.png": 70555,
	"./clinic-06.png": 39619,
	"./clinic-07.png": 91227,
	"./clinic-08.png": 41523,
	"./clinic-09.png": 95910,
	"./clinic-10.png": 47326,
	"./clinic-11.png": 31294,
	"./clinic-12.png": 1846,
	"./clinic-13.png": 4147,
	"./clinic-hover-01.png": 24927,
	"./clinic-hover-02.png": 42679,
	"./clinic-hover-03.png": 58481,
	"./clinic-hover-04.png": 20603,
	"./clinic-hover-05.png": 68918,
	"./clinic-hover-06.png": 26971,
	"./clinic-hover-07.png": 94466,
	"./clinic-hover-08.png": 88547,
	"./clinic-hover-09.png": 60317,
	"./clinic-hover-10.png": 77582,
	"./comment-icon.svg": 91240,
	"./contact-icon1.svg": 74824,
	"./count-01.svg": 49808,
	"./count-02.svg": 58937,
	"./count-03.svg": 29408,
	"./count-04.svg": 5648,
	"./customer-service-1.svg": 73034,
	"./customer-service-2.svg": 91748,
	"./device-message.svg": 76348,
	"./device-message2.svg": 34567,
	"./discover-1.svg": 11552,
	"./discover-2.svg": 72422,
	"./discover-3.svg": 10996,
	"./discover-4.svg": 42867,
	"./discover-5.svg": 38961,
	"./doc-01.svg": 7394,
	"./doc-02.svg": 56610,
	"./doc-03.svg": 526,
	"./doct-01.png": 80744,
	"./doct-02.png": 93987,
	"./doctor-icon.svg": 82142,
	"./down-arrow-gray-dark.svg": 74980,
	"./down-arrow-gray.svg": 89914,
	"./drugs-svg - Copy.svg": 7795,
	"./drugs-svg.svg": 44525,
	"./drugs.svg": 49620,
	"./edit.svg": 62365,
	"./email-icon.svg": 45107,
	"./email.svg": 91802,
	"./emoj-icon-01.svg": 72369,
	"./emoj-icon-02.svg": 53959,
	"./emoj-icon-03.svg": 56827,
	"./emoj-icon-04.svg": 45475,
	"./emoj-icon-05.svg": 23703,
	"./experience-1.svg": 82514,
	"./experience-2.svg": 99047,
	"./experience-3.svg": 79208,
	"./experience-4.svg": 31587,
	"./experience-5.svg": 76401,
	"./experience-6.svg": 85193,
	"./experience-logo-01.svg": 57769,
	"./experience-logo-02.svg": 15100,
	"./eye-bg.png": 32883,
	"./eye-icon-01.svg": 99696,
	"./eye-icon.svg": 80475,
	"./eye-white-icon.svg": 84554,
	"./eyecare-icon-01.svg": 77882,
	"./eyecare-icon-02.svg": 6329,
	"./eyecare-icon-03.svg": 41963,
	"./facts-1.svg": 65531,
	"./facts-2.svg": 28039,
	"./facts-3.svg": 50109,
	"./facts-4.svg": 671,
	"./facts-5.svg": 25491,
	"./faq-sec-bg-icon.svg": 8427,
	"./fb-icon.svg": 78938,
	"./female.png": 1146,
	"./fifteen-play.svg": 67267,
	"./file.png": 98940,
	"./flow-chart-icon-01.svg": 17849,
	"./flow-chart-icon-02.svg": 66103,
	"./flow-chart-icon-03.svg": 75039,
	"./flow-chart-icon-04.svg": 95869,
	"./fluent-password.svg": 69744,
	"./footer-card-icon-01.svg": 26168,
	"./footer-card-icon-02.svg": 83247,
	"./footer-card-icon-03.svg": 23356,
	"./footer-card-icon-04.svg": 38311,
	"./footer-logo-.svg": 46911,
	"./gem.svg": 49250,
	"./globe.svg": 11909,
	"./google-icon.svg": 17012,
	"./google-play-icon.svg": 16333,
	"./google-play.svg": 17310,
	"./header-icon.svg": 8525,
	"./health-care-1.svg": 74911,
	"./health-care-love - Copy.svg": 47314,
	"./health-care-love.svg": 32835,
	"./healthcare - Copy.svg": 86170,
	"./healthcare.svg": 58371,
	"./heart-2.svg": 66158,
	"./heart-icon.svg": 17305,
	"./heart-pulse-fill.svg": 16437,
	"./heart-pulse.svg": 17512,
	"./heart.svg": 57583,
	"./hex-shape.png": 29410,
	"./hreat-pulse.svg": 50077,
	"./injection.svg": 55479,
	"./instagram-icon.svg": 58987,
	"./insurence-logo-01.svg": 62175,
	"./insurence-logo-02.svg": 44479,
	"./insurence-logo-03.svg": 21831,
	"./insurence-logo-04.svg": 63744,
	"./insurence-logo-05.svg": 82235,
	"./insurence-logo-06.svg": 13226,
	"./lab-service-icon-01.svg": 99673,
	"./lab-service-icon-02.svg": 30966,
	"./lab-service-icon-03.svg": 18119,
	"./lab-view-icon.svg": 75465,
	"./like.svg": 33747,
	"./linkedin-icon.svg": 25015,
	"./lock.svg": 26662,
	"./login-user-circle.svg": 73505,
	"./male.png": 66073,
	"./medal-icon.svg": 94767,
	"./medical-icon-01.svg": 47376,
	"./medical-icon-02.svg": 25590,
	"./medical-icon-03.svg": 4614,
	"./medical-icon-04.svg": 66116,
	"./medicine-icon.svg": 30754,
	"./mic-black.svg": 77478,
	"./mobile-icon.svg": 13895,
	"./mobile.svg": 49298,
	"./nurse-slide-badge-01.svg": 28162,
	"./nurse-slide-badge-02.svg": 22361,
	"./order-icon.svg": 91965,
	"./package-icon-01.svg": 90670,
	"./package-icon-02.svg": 50150,
	"./password-duotone.svg": 70153,
	"./patient-icon.svg": 74089,
	"./payment-card.png": 85554,
	"./payment-icon-01.svg": 26546,
	"./payment-icon-02.svg": 59105,
	"./payment-icon-03.svg": 70766,
	"./payment-icon-04.svg": 43964,
	"./paypal.svg": 45453,
	"./pet-doctor.svg": 15647,
	"./phone-icon.svg": 31248,
	"./phone.png": 53375,
	"./play-01.svg": 69054,
	"./price-icon-04.svg": 69160,
	"./price-icon-05.svg": 64113,
	"./price-icon-06.svg": 88531,
	"./price-icon1.svg": 46402,
	"./price-icon2.svg": 26841,
	"./price-icon3.svg": 64596,
	"./price-sticker-ribbon.svg": 22323,
	"./product-icon-01.svg": 48752,
	"./product-icon-02.svg": 74036,
	"./product-icon-03.svg": 72558,
	"./product-icon-04.svg": 49775,
	"./quatation-img.svg": 51225,
	"./rainbow-1.png": 66377,
	"./rainbow-3.svg": 27230,
	"./rainbow-4.svg": 92617,
	"./rainbow-5.svg": 18696,
	"./review-thumb.svg": 63450,
	"./search-icon.svg": 28356,
	"./section-small-icon-01.svg": 78302,
	"./section-small-icon-02.svg": 44018,
	"./serv-img-icon-1.svg": 24928,
	"./serv-img-icon-2.svg": 5790,
	"./serv-img-icon-3.svg": 14707,
	"./service-01.svg": 97517,
	"./service-02.svg": 98130,
	"./service-03.svg": 28945,
	"./service-04.svg": 46491,
	"./service-05.svg": 92750,
	"./service-06.svg": 65558,
	"./service-07.svg": 96895,
	"./set-cat-01.png": 37405,
	"./set-cat-02.png": 6991,
	"./set-cat-03.png": 20772,
	"./shopping-bag.svg": 89618,
	"./signup-unlock.svg": 20787,
	"./signup-users.svg": 78895,
	"./slider-plugin-icon-01.svg": 7297,
	"./slider-plugin-icon-02.svg": 62369,
	"./slider-plugin-icon-03.svg": 97453,
	"./slider-plugin-icon-04.svg": 7479,
	"./slider-plugin-icon-05.svg": 51259,
	"./slider-plugin-icon-06.svg": 91945,
	"./smart-phone.svg": 51298,
	"./smile-chat.svg": 61320,
	"./smile.svg": 52174,
	"./smiling-icon.svg": 21007,
	"./star.svg": 55548,
	"./sticker-icon.svg": 40507,
	"./stripe.svg": 20178,
	"./success-tick.svg": 99584,
	"./syringe-svg.svg": 30382,
	"./syringe.svg": 57450,
	"./tag-icon.svg": 32361,
	"./test-icon-01.svg": 993,
	"./test-icon-02.svg": 84269,
	"./test-icon-03.svg": 61050,
	"./test-icon-04.svg": 2214,
	"./test-line.svg": 72893,
	"./thumb-icon.svg": 89603,
	"./tick-icon.svg": 40235,
	"./today-icon.svg": 65113,
	"./up-cam.png": 81584,
	"./up-img-1.svg": 71181,
	"./user-circle.svg": 68759,
	"./user-doctor - Copy.svg": 24536,
	"./user-doctor.svg": 44854,
	"./various-logo-01.svg": 98604,
	"./various-logo-02.svg": 17440,
	"./various-logo-03.svg": 41264,
	"./various-logo-04.svg": 60539,
	"./various-logo-05.svg": 2357,
	"./various-logo-06.svg": 44922,
	"./video-icon.svg": 43534,
	"./visit-01.png": 461,
	"./visit-02.png": 94666,
	"./visit-03.png": 85518,
	"./voice.svg": 56164,
	"./watch-icon.svg": 34196,
	"./we-are-icon1.svg": 45477,
	"./we-are-icon2.svg": 97596,
	"./we-are-icon3.svg": 99624,
	"./work-01.svg": 10517,
	"./work-02.svg": 99791,
	"./work-03.svg": 35954,
	"./work-04.svg": 77121,
	"./work-icon-05.svg": 5245,
	"./work-icon-06.svg": 81182,
	"./work-icon-07.svg": 66135,
	"./x-icon-01.png": 82799,
	"./x-icon.svg": 16374,
	"./x-twitter-icon.svg": 99473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41199;